import { render, staticRenderFns } from "./Multi.vue?vue&type=template&id=f0b9ccbc&"
import script from "./Multi.vue?vue&type=script&lang=js&"
export * from "./Multi.vue?vue&type=script&lang=js&"
import style0 from "./Multi.vue?vue&type=style&index=0&id=f0b9ccbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports